import { Component } from '@verndale/core';
import clickOutside from 'click-outside';
import { iOS, isMobile } from '../helpers';
import 'waypoints/lib/noframework.waypoints.min.js';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $toc: this.el._$('.table-of-contents__toc'),
      $mobileExpandTrigger: this.el._$('.table-of-contents__toc-heading-actions-wrapper'),
      $mobileCollapserigger: this.el._$('.table-of-contents__close-trigger'),
      $tocItemsContainer: this.el._$('.table-of-contents__toc-items'),
      $interestCallout: _$('.interest-callout'),
      $interesetCta: this.el._$('.course-detail__cta'),
      $titles: [...this.el._$$('.course-info__title'), ...this.el._$$('.accordion__heading')]
    };

    if (!this.dom.$titles.length) return;

    this.idPrefix = 'course-detail-title';
    this.tocTemplate = item => `
      <li class="table-of-contents__toc-item">
        <a class="link table-of-contents__toc-anchor" href="#${item.id}">${item.label}</a>
      </li>
    `;

    this.collapsedTocClass = 'table-of-contents__toc--mobile-collapsed';
    this.mobileWrapperHeight = this.dom.$mobileExpandTrigger.offsetHeight;

    this.addIdsToTitles();
    this.renderTocs();

    this.dom.$navItems = this.el._$$('.table-of-contents__toc-anchor');
    this.updateToc(`#${this.dom.$titles[0].id}`);
  }

  addListeners() {
    this.dom.$navItems._on('click', this.handleNavItemsClick.bind(this));
    this.dom.$mobileExpandTrigger._on('click', this.expandToc.bind(this));
    this.dom.$mobileCollapserigger._on('click', this.collapseToc.bind(this));
    if (this.dom.$interesetCta) this.dom.$interesetCta._on('click', this.handleInteresetCtaClick.bind(this));
  }

  addIdsToTitles() {
    this.dom.$titles.forEach((el, i) => el.id = `${this.idPrefix}-${i}`)
  }

  renderTocs() {
    let html = '';
    this.dom.$titles.forEach(title => {
      const waypoint = new window.Waypoint({
        element: title,
        handler: () => {
          this.handleWaypointTrigger(waypoint);
        },
        offset: isMobile() ? '45%' : '25%'
      });

      html += this.tocTemplate({ label: title.textContent, id: title.id });
    });

    this.dom.$tocItemsContainer.innerHTML = html;
  }

  updateToc(hash) {
    if (!hash) hash = `#${this.highlightedElement.id}`;
    const navEl = document.querySelector(`a[href="${hash}"]`);

    this.dom.$navItems.forEach(el => el.removeAttribute('aria-current'));
    this.dom.$navItems.forEach(el => el.classList.add('link--dark'));
    navEl.setAttribute('aria-current', 'page');
    navEl.classList.remove('link--dark');
  }

  expandToc() {
    this.dom.$toc.classList.remove(this.collapsedTocClass);
    this.unbindTocOutsideClick = clickOutside(
      this.dom.$toc,
      this.collapseToc.bind(this)
    );

    if (isMobile()) {
      if (!this.initialWrapperHeight) this.initialWrapperHeight = this.dom.$mobileTocWrapper.offsetHeight;

      if (iOS()) {
        this.dom.$mobileTocWrapper.style.top = `calc(100vh - ${this.initialWrapperHeight + 130}px)`;
      } else {
        this.dom.$mobileTocWrapper.style.top = `calc(100vh - ${this.initialWrapperHeight + 10}px)`;
      }

      // avoid adding extra spacing on top
      window.requestAnimationFrame(() => {
        this.dom.$mobileTocWrapper.style.height = `${this.mobileWrapperHeight}px`;
      })
    }
  }

  collapseToc() {
    this.dom.$toc.classList.add(this.collapsedTocClass);
    this.unbindTocOutsideClick?.();

    if (isMobile()) {
      if (iOS()) {
        this.dom.$mobileTocWrapper.style.top = 'calc(100vh - 180px)';
      } else {
        this.dom.$mobileTocWrapper.style.top = 'calc(100vh - 60px)';
      }
    }
  }

  handleNavItemsClick(e) {
    e.preventDefault();

    const $el = e.target;
    const id = $el.href.split('#')[1];
    const $target = document.getElementById(id);
    const topTarget = window.pageYOffset + $target.getBoundingClientRect().top - 20;

    this.menuTriggeredScroll = true;
    this.updateToc(`#${id}`);

    window.scroll({
      left: 0,
      top: topTarget,
      behavior: 'smooth'
    });

    this.setScrollInterval = setInterval(() => {
      if (this.lastScrollPosition === window.pageYOffset) {
        this.menuTriggeredScroll = false;
        clearInterval(this.setScrollInterval);
      } else {
        this.lastScrollPosition = window.pageYOffset;
      }
    }, 100);
  }

  handleWaypointTrigger(waypoint) {
    if (this.menuTriggeredScroll) return;
    this.highlightedElement = waypoint.element;
    this.updateToc();
  }

  handleInteresetCtaClick(e) {
    e.preventDefault();
    if (!this.dom.$interestCallout) return;

    const top = window.pageYOffset + this.dom.$interestCallout.getBoundingClientRect().top - 20;

    window.scroll({
      left: 0,
      top,
      behavior: 'smooth'
    });
  }
}

export default Module;
